import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type FolderIconProps = Omit<BaseIconProps, 'children'>;

export const FolderIcon = ({ ...props }: FolderIconProps) => (
  <BaseIcon hasLegacyStrokeStyles={false} width="16" height="14" viewBox="0 0 16 14" fill="none" {...props}>
    <g fill="#141B4D" fillRule="evenodd" clipRule="evenodd">
      <path d="M0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 .707.293l3 3A1 1 0 0 1 9 5H1a1 1 0 0 1-1-1V1Z" />
      <path d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2 1v7h12V5H2Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v14H0z" />
      </clipPath>
    </defs>
  </BaseIcon>
);

FolderIcon.displayName = 'FolderIcon';
